"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var forms_1 = require("@angular/forms");
var job_reference_service_1 = require("../job-reference.service");
var JobReferenceCreateModalComponent = /** @class */ (function () {
    function JobReferenceCreateModalComponent(formBuilder, jobReferenceService, dialogRef, data) {
        this.formBuilder = formBuilder;
        this.jobReferenceService = jobReferenceService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.referenceForm = this.formBuilder.group({
            value: [''],
            destination: [''],
            haulRate: [''],
            invoiceRate: [''],
            jobCode: [''],
            jobName: [''],
            material: [''],
            origin: [''],
            orderNumber: [''],
        });
        this.mode = 'create';
    }
    JobReferenceCreateModalComponent.prototype.ngOnInit = function () {
        if (this.data.model) {
            this.setFormFieldData(this.data.model);
        }
        this.mode = this.data.mode;
    };
    JobReferenceCreateModalComponent.prototype.onSubmit = function () {
        var value = this.referenceForm.value;
        if (this.data.model) {
            value = __assign({}, this.data.model, this.referenceForm.value);
        }
        this.callback(this.jobReferenceService.save(value));
        this.dialogRef.close();
    };
    JobReferenceCreateModalComponent.prototype.setFormFieldData = function (data) {
        this.referenceForm.controls['value'].setValue(data.value);
        this.referenceForm.controls['destination'].setValue(data.destination);
        this.referenceForm.controls['haulRate'].setValue(data.haulRate);
        this.referenceForm.controls['invoiceRate'].setValue(data.invoiceRate);
        this.referenceForm.controls['jobCode'].setValue(data.jobCode);
        this.referenceForm.controls['jobName'].setValue(data.jobName);
        this.referenceForm.controls['material'].setValue(data.material);
        this.referenceForm.controls['origin'].setValue(data.origin);
        this.referenceForm.controls['orderNumber'].setValue(data.orderNumber);
    };
    return JobReferenceCreateModalComponent;
}());
exports.JobReferenceCreateModalComponent = JobReferenceCreateModalComponent;
